// 首页
import request from '@/utils/request'

export function getDetailByMcuId(params) {
  return request({
    url: '/v2/device/getDetailByMcuId',
    method: 'post',
    data: params
  })
}
export function listMsgBMSData(params) {
  return request({
    // url: '/v3/gps/getGNSSByMcuID',
    url: '/v3/canbus/listMsgBMSData',
    // url: '/v2/device/getDetailByMcuId',
    method: 'post',
    // headers: { 'token': 'nmamtf' },
    data: params,
    responseType: 'arraybuffer'
  })
}
